<template>
  <div class="menu-container">
    <el-menu :default-active="activeIndex" class="el-menu-vertical-demo"
             :collapse="isCollapse" @select="handleSelect">
      <div class="brand-header">
        <el-image style="height: 32px;"
                  src="https://scriptmaster.darknight.games/ConfigNaoDong/9392acf9-7c51-4afa-9dfe-4dd92c6c5eb0.png"/>
        <span class="brand-title">幻视服务平台</span>
      </div>

      <el-submenu index="1" style="margin-top: 8px; font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-if="hasPermission('juliang')">
        <template slot="title">
          <span slot="title" class="span-1">
           <svg t="1741761487321" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="12088" width="22" height="22"><path
               d="M0 0m341.333333 0l341.333334 0q341.333333 0 341.333333 341.333333l0 341.333334q0 341.333333-341.333333 341.333333l-341.333334 0q-341.333333 0-341.333333-341.333333l0-341.333334q0-341.333333 341.333333-341.333333Z"
               fill="#FFFFFF" p-id="12089"></path><path
               d="M465.806222 177.777778l138.638222-32.028445 117.361778 204.8-95.857778 99.214223z" fill="#00C9D0"
               p-id="12090"></path><path
               d="M783.928889 305.777778l97.848889 102.4-120.718222 201.614222-135.281778-32.426667z" fill="#008CFA"
               p-id="12091"></path><path
               d="M833.763556 625.777778l-41.699556 143.985778-239.274667-1.763556-39.025777-140.458667z" fill="#0069CD"
               p-id="12092"></path><path
               d="M577.763556 849.749333L439.182222 881.777778l-117.361778-204.8 95.800889-99.214222z" fill="#005BAA"
               p-id="12093"></path><path d="M259.584 721.806222l-97.848889-102.4 120.832-201.614222 135.224889 32.483556z"
                                         fill="#0069CD" p-id="12094"></path><path
               d="M209.806222 385.763556L251.448889 241.777778l239.274667 1.706666 39.082666 140.401778c-0.113778 0.113778-320.056889 1.877333-320.056889 1.877334z"
               fill="#00E7DC" p-id="12095"></path></svg>
            <span> 巨量抖音</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in juliangMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="11" style="margin-top: 8px; font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-if="hasPermission('projectSummary')">
        <template slot="title">
          <span slot="title" class="span-1">
            <i class="el-icon-document" style="font-size: 20px; margin-right: 4px; color: #409eff;"></i>
            <span> 项目汇总</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in projectSummaryMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="8" style="margin-top: 8px; font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-if="hasPermission('juliang')">
        <template slot="title">
          <span slot="title" class="span-1">
           <svg t="1741761487321" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="12088" width="22" height="22"><path
               d="M0 0m341.333333 0l341.333334 0q341.333333 0 341.333333 341.333333l0 341.333334q0 341.333333-341.333333 341.333333l-341.333334 0q-341.333333 0-341.333333-341.333333l0-341.333334q0-341.333333 341.333333-341.333333Z"
               fill="#FFFFFF" p-id="12089"></path><path
               d="M465.806222 177.777778l138.638222-32.028445 117.361778 204.8-95.857778 99.214223z" fill="#00C9D0"
               p-id="12090"></path><path
               d="M783.928889 305.777778l97.848889 102.4-120.718222 201.614222-135.281778-32.426667z" fill="#008CFA"
               p-id="12091"></path><path
               d="M833.763556 625.777778l-41.699556 143.985778-239.274667-1.763556-39.025777-140.458667z" fill="#0069CD"
               p-id="12092"></path><path
               d="M577.763556 849.749333L439.182222 881.777778l-117.361778-204.8 95.800889-99.214222z" fill="#005BAA"
               p-id="12093"></path><path d="M259.584 721.806222l-97.848889-102.4 120.832-201.614222 135.224889 32.483556z"
                                         fill="#0069CD" p-id="12094"></path><path
               d="M209.806222 385.763556L251.448889 241.777778l239.274667 1.706666 39.082666 140.401778c-0.113778 0.113778-320.056889 1.877333-320.056889 1.877334z"
               fill="#00E7DC" p-id="12095"></path></svg>
            <span> tiktok抖音</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in tiktokMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>




      <el-submenu index="3" style="margin-top: 10px; font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-if="hasPermission('tencent')">
        <template slot="title">
          <span slot="title" class="span-1">
           <svg t="1741761246643" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="10779" width="22" height="22"><path
               d="M8.533333 8.533333m88.177778 0l830.577778 0q88.177778 0 88.177778 88.177778l0 830.577778q0 88.177778-88.177778 88.177778l-830.577778 0q-88.177778 0-88.177778-88.177778l0-830.577778q0-88.177778 88.177778-88.177778Z"
               fill="#F4F8FF" p-id="10780"></path><path
               d="M927.288889 17.066667a79.644444 79.644444 0 0 1 79.644444 79.644444v830.577778a79.644444 79.644444 0 0 1-79.644444 79.644444H96.711111a79.644444 79.644444 0 0 1-79.644444-79.644444V96.711111A79.644444 79.644444 0 0 1 96.711111 17.066667h830.577778m0-17.066667H96.711111A96.711111 96.711111 0 0 0 0 96.711111v830.577778A96.711111 96.711111 0 0 0 96.711111 1024h830.577778a96.711111 96.711111 0 0 0 96.711111-96.711111V96.711111A96.711111 96.711111 0 0 0 927.288889 0z"
               fill="#DEEBFF" p-id="10781"></path><path
               d="M596.195556 507.448889c-13.084444 18.204444-27.875556 35.271111-42.097778 52.337778-33.564444 41.528889-67.697778 82.488889-98.986667 122.88-12.515556 15.36-25.031111 31.288889-38.115555 46.08a67.128889 67.128889 0 0 1-67.697778 21.617777 62.577778 62.577778 0 0 1-50.631111-48.924444 56.888889 56.888889 0 0 1 13.084444-53.475556c19.911111-24.462222 39.822222-48.355556 56.888889-72.817777L455.111111 468.764444c10.24-13.084444 20.48-26.737778 31.857778-39.253333l4.551111-3.982222h2.844444a14.791111 14.791111 0 0 0 6.826667-2.844445 61.44 61.44 0 0 1 32.995556-7.964444 67.697778 67.697778 0 0 1 43.804444 15.36 64.853333 64.853333 0 0 1 23.893333 47.217778 96.711111 96.711111 0 0 1-5.12 28.444444z m-300.373334 39.253333a64.284444 64.284444 0 0 1-56.888889-35.271111 56.888889 56.888889 0 0 1 6.257778-66.56c18.204444-23.324444 37.546667-45.511111 56.888889-68.835555l68.266667-83.057778a68.266667 68.266667 0 0 1 113.777777 7.964444 56.888889 56.888889 0 0 1-5.12 68.266667c-26.737778 34.133333-56.888889 67.697778-82.488888 101.262222l-41.528889 50.631111a69.973333 69.973333 0 0 1-56.888889 25.6z"
               fill="#2D69F0" p-id="10782"></path><path
               d="M614.4 568.888889a10.24 10.24 0 0 1 0-6.257778l43.804444-56.888889 39.822223-53.475555c5.12-6.826667 9.102222-13.653333 14.791111-19.911111A60.871111 60.871111 0 0 1 796.444444 424.96a68.266667 68.266667 0 0 1 7.395556 97.28l-33.564444 44.942222-49.493334 65.991111-10.24 13.653334s0 2.844444-3.413333 2.844444 0-2.844444 0-3.982222A65.422222 65.422222 0 0 0 682.666667 568.888889a56.888889 56.888889 0 0 0-65.991111 0h-3.982223z m-20.48-63.715556a113.777778 113.777778 0 0 0 4.551111-27.875555 68.835556 68.835556 0 0 0-22.186667-47.786667 56.888889 56.888889 0 0 0-39.253333-15.36 56.888889 56.888889 0 0 0-30.151111 7.964445 10.808889 10.808889 0 0 1-5.688889 0c0-5.12 3.982222-7.964444 6.826667-11.946667 15.36-21.048889 30.72-42.666667 46.648889-63.715556s30.72-40.96 46.648889-60.871111a56.888889 56.888889 0 0 1 38.684444-20.48 56.888889 56.888889 0 0 1 51.2 21.048889 56.888889 56.888889 0 0 1 15.36 32.995556 71.111111 71.111111 0 0 1-17.066667 56.888889l-42.097777 56.888888c-17.066667 22.186667-33.564444 44.942222-50.062223 67.128889h-3.413333z"
               fill="#91D3FE" p-id="10783"></path><path
               d="M77.937778 690.062222a72.248889 72.248889 0 0 1 15.928889-44.942222c12.515556-15.36 23.893333-31.288889 35.84-47.217778l12.515555-16.497778a60.871111 60.871111 0 0 1 42.666667-22.186666 56.888889 56.888889 0 0 1 56.888889 29.582222 64.284444 64.284444 0 0 1 3.982222 63.146667 125.724444 125.724444 0 0 1-17.066667 25.6l-38.684444 51.2a61.44 61.44 0 0 1-97.848889 3.982222 59.733333 59.733333 0 0 1-15.36-42.666667z"
               fill="#FEA704" p-id="10784"></path><path
               d="M608.142222 568.888889h3.982222a61.44 61.44 0 0 1 67.128889 0 65.991111 65.991111 0 0 1 24.462223 77.368889v3.982222c-11.377778 18.773333-26.168889 35.84-39.253334 53.475556-5.688889 8.533333-11.946667 16.497778-18.204444 24.462222a56.888889 56.888889 0 0 1-48.924445 25.6 60.302222 60.302222 0 0 1-60.302222-43.804445 64.284444 64.284444 0 0 1 9.671111-61.44l49.493334-65.991111 7.395555-8.533333v-2.844445z"
               fill="#2D69F0" p-id="10785"></path><path
               d="M878.933333 559.217778a65.422222 65.422222 0 0 1 64.284445 50.062222 66.56 66.56 0 0 1-14.791111 56.888889l-39.822223 49.493333a184.888889 184.888889 0 0 1-13.084444 16.497778 69.404444 69.404444 0 0 1-42.097778 21.048889 63.146667 63.146667 0 0 1-56.888889-19.911111 61.44 61.44 0 0 1-14.791111-65.422222 97.28 97.28 0 0 1 17.066667-28.444445c15.36-19.342222 30.72-39.253333 47.217778-56.888889a62.008889 62.008889 0 0 1 51.768889-23.324444z"
               fill="#91D3FE" p-id="10786"></path></svg>
            <span> 腾讯广告</span>
          </span>
        </template>
        <el-menu-item v-for="item in tencentMenuItems"
                      :key="item.index"
                      :index="item.index"
                      class="span-1-1">
          {{ item.name }}
        </el-menu-item>
      </el-submenu>


      <el-submenu index="6" style="margin-top: 10px;" v-if="hasPermission('video')">
        <template slot="title">
          <span slot="title" class="span-1">
        <svg t="1755847780062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1872" width="22" height="22"><path d="M143.392 131.744c81.824-24.576 180.032 70.464 336.064 325.248 17.536 28.608 32.544 52 33.376 52.032 0.832 0 16.64-24.768 35.072-55.04 155.168-254.56 253.44-348.096 336.896-320.704 53.024 17.408 75.392 68.608 75.2 172.16-0.384 201.44-97.216 517.12-176.256 574.592-65.088 47.296-162.336-12.256-252.992-154.976-8.992-14.208-17.216-25.856-18.208-25.888-0.992 0-8.992 11.552-17.76 25.728-47.776 77.248-106.368 137.12-156.608 160.032-24.416 11.136-66.88 12.672-84.8 3.04-48.832-26.24-103.808-140.16-146.4-303.488C38.912 323.52 52.16 159.2 143.392 131.744zM827.296 235.52c-51.808 40.256-118.592 129.92-216.384 290.56l-46.176 75.776 15.808 28.288c39.712 71.2 85.6 131.072 122.624 160 25.088 19.648 33.376 15.52 55.296-27.648 68.928-135.52 127.68-413.184 108.48-512.992-5.76-30.048-14.816-33.248-39.648-13.984zM166.752 226.976c-18.496 18.272-13.696 136.704 10.304 254.912 28.96 142.72 89.92 308.736 116.736 318.048 26.08 9.056 97.792-72.96 154.112-176.256l12.32-22.624-39.52-64.864c-105.92-173.76-174.976-266.592-225.792-303.488-15.616-11.328-21.312-12.48-28.16-5.728z" fill="#FF9908" p-id="1873"></path></svg> <span> 视频号</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in videoMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="10" style="margin-top: 10px;" v-if="hasPermission('aigc')">
        <template slot="title">
          <span slot="title" class="span-1">
            <i class="el-icon-magic-stick" style="font-size: 20px; margin-right: 4px; color: #67c23a;"></i>
            <span> AI工具</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in aigcMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>



      <el-submenu index="2" style="margin-top: 10px;" v-if="hasPermission('warning')">
        <template slot="title">
          <span slot="title" class="span-1">
          <svg t="1741835123218" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="15444" width="22" height="22"><path
              d="M1024.769684 559.111055a464.696524 464.696524 0 0 1-464.760664 464.888945H465.466207A464.696524 464.696524 0 0 1 0.577263 559.111055V464.953085A464.888945 464.888945 0 0 1 465.466207 0h94.542813a464.824804 464.824804 0 0 1 464.760664 464.888945v94.22211z"
              fill="#FE6668" p-id="15445"></path><path
              d="M512.673473 825.229189a62.60094 62.60094 0 0 1-45.860319-18.79311 60.997432 60.997432 0 0 1-18.85725-44.449233h127.895772a60.805011 60.805011 0 0 1-18.087567 45.090636 61.253993 61.253993 0 0 1-45.090636 18.151707z m192.805763-352.322706v159.645224l64.84585 64.78171v31.557031H255.278422v-31.557031L320.124272 632.423426V472.906483c0-50.22186 12.699781-93.901409 38.355903-131.038647 25.591982-37.137238 60.933292-61.253993 106.088068-72.221986v-22.641528a47.463827 47.463827 0 0 1 13.597745-33.866082 45.154776 45.154776 0 0 1 34.571626-14.303289c14.175008 0 25.591982 4.810523 34.699906 14.303289a47.014845 47.014845 0 0 1 13.533604 33.866082v22.641528c45.090636 11.032133 80.624366 35.148888 106.152208 72.221986 25.527842 37.137238 38.420044 80.816787 38.355904 131.038647z m63.242342-16.61234c-4.938804-86.332853-42.717444-155.027122-113.01522-206.275227l45.154776-45.090635c83.382399 64.140307 127.51093 148.035828 132.449734 251.365862h-64.58929zM371.179956 249.954776c-71.195741 50.22186-109.359223 119.04441-114.362167 206.339367H191.971939c5.002944-103.394175 49.195615-187.225556 132.578014-251.430003l46.630003 45.090636z"
              fill="#FFFFFF" p-id="15446"></path></svg>
            <span> 报警监控</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in warningMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="9" style="margin-top: 10px;" v-if="hasPermission('admin')">
        <template slot="title">
          <span slot="title" class="span-1">
            <i class="el-icon-setting" style="font-size: 20px; margin-right: 4px;"></i>
            <span> 管理</span>
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="item in adminMenuItems"
                        :key="item.index"
                        :index="item.index"
                        class="span-1-1">
            {{ item.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <span class="back-login" @click="back()">返回登录</span>
    </el-menu>
  </div>
</template>

<script>
import { routeMap, allMenuItems } from './menuConfig'

export default {
  name: "Header",

  data() {
    return {
      loading: false,
      activeIndex: '1',
      activeIndex2: '1',
      modelinfo: this.$store.state.user.username,
      mod: [false, false, false, false, false, false, false, false, false, false],
      isCollapse: false,
      width: '150px',
      userPermissions: [], // 用户权限列表
      userMenuConfig: {}   // 用户菜单配置


    }
  },   computed: {
    // 根据用户配置过滤巨量抖音菜单项
    juliangMenuItems() {
      if (!this.userMenuConfig.juliang) return [];
      return allMenuItems.juliang.filter(item =>
          this.userMenuConfig.juliang.includes(item.index)
      );
    }, // 根据用户配置过滤TikTok抖音菜单项
    projectSummaryMenuItems() {
      if (!this.userMenuConfig.projectSummary) return [];
      return allMenuItems.projectSummary.filter(item =>
          this.userMenuConfig.projectSummary.includes(item.index)
      );
    },
    tiktokMenuItems() {
      if (!this.userMenuConfig.juliang) return [];
      return allMenuItems.tiktok.filter(item =>
          this.userMenuConfig.juliang.includes(item.index)
      );
    },

    // 根据用户配置过滤腾讯广告菜单项
    tencentMenuItems() {
      if (!this.userMenuConfig.tencent) return [];
      const selected = this.userMenuConfig.tencent.slice()
      if (selected.includes('4-14') && !selected.includes('4-15')) {
        selected.push('4-15')
      }
      return allMenuItems.tencent.filter(item =>
          selected.includes(item.index)
      );
    },

    // 根据用户配置过滤报警监控菜单项
    warningMenuItems() {
      if (!this.userMenuConfig.warning) return [];
      return allMenuItems.warning.filter(item =>
          this.userMenuConfig.warning.includes(item.index)
      );
    },
    videoMenuItems() {
      if (!this.userMenuConfig.video) return [];
      return allMenuItems.video.filter(item =>
          this.userMenuConfig.video.includes(item.index)
      );
    },
    aigcMenuItems() {
      if (!this.userMenuConfig.aigc) return [];
      return allMenuItems.aigc.filter(item =>
          this.userMenuConfig.aigc.includes(item.index)
      );
    },
    adminMenuItems() {
      if (!this.userMenuConfig.admin) return [];
      return allMenuItems.admin.filter(item =>
          this.userMenuConfig.admin.includes(item.index)
      );
    }
  },mounted: function () {
    this.fetchUserMenuConfig();

  },
  methods: { // 获取用户菜单配置
    async fetchUserMenuConfig() {
      try {
        // 这里应该调用后端API获取用户菜单配置
        // 示例：
        const response = await this.$http.get('/tf2/data/user/menuConfig');
        this.userMenuConfig = this.normalizeUserMenuConfig(response.data.data);



        // 或者根据用户角色设置权限
        // this.setUserPermissionsByRole();
      } catch (error) {
        console.error('获取用户菜单配置失败:', error);
      }
    },
    normalizeUserMenuConfig(config) {
      const normalized = Object.assign({}, config || {})
      const allAigcIndexes = allMenuItems.aigc.map(item => item.index)
      if (!Array.isArray(normalized.aigc)) {
        normalized.aigc = allAigcIndexes
      } else if (normalized.aigc.length > 0) {
        normalized.aigc = Array.from(new Set(normalized.aigc.concat(allAigcIndexes)))
      }
      if (!Array.isArray(normalized.projectSummary)) {
        normalized.projectSummary = []
      }
      if (Array.isArray(normalized.video)
          && ['6-1', '6-2', '6-3'].every(index => normalized.video.includes(index))
          && !normalized.video.includes('6-4')) {
        normalized.video = normalized.video.concat('6-4')
      }
      return normalized
    },
    // 检查是否有某个模块的权限
    hasPermission(module) {
      return this.userMenuConfig[module] && this.userMenuConfig[module].length > 0;
    },
    back() {
      this.$router.push({path: '/Login', name: 'Login'})

    },

    get() {

      return this.width

    }, handleSelect(key, keyPath) {
      try {
        const route = routeMap[key];
        if (route) {
          this.$router.push(route);
        }
      } catch (error) {
        console.warn(`No route found for key: ${key}`);
      }
    }

  }
}


</script>

<style scoped>

.menu-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #1f1f1f;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
}

.brand-header {
  display: flex;
  align-items: center;
  padding: 16px 8px 14px;
  color: #ffffff;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
}

.brand-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
}

.el-menu-vertical-demo {
  transition: all 0.3s ease;
  border-right: 0;
  background-color: #1f1f1f;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 170px;
  height: 100%;
  color: #e5e7eb;
  background-color: #1f1f1f;
}

.el-menu-item-group,
.el-menu-item,
.el-submenu .el-menu-item {
  background-color: #1f1f1f;
  min-width: 170px;
  position: relative;
}

::v-deep .el-submenu__title,
.el-menu-item {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 400;
  color: #e5e7eb;
  letter-spacing: 0;
}

.span-1 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #f2f3f5;
  letter-spacing: 0;
}

.span-1 svg,
.span-1 i {
  flex: 0 0 auto;
}

.span-1-1 {
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  color: #e5e7eb;
  letter-spacing: 0;
}

::v-deep .el-submenu__title i,
::v-deep .el-submenu__icon-arrow {
  color: #9ca3af;
}

::v-deep .el-submenu__title:hover,
.el-menu-item:hover {
  background-color: #333333 !important;
  color: #ffffff !important;
}

.el-menu-item.is-active {
  background-color: #252d44 !important;
  color: #ffffff !important;
  font-weight: 500;
}

.el-menu-item.is-active::before {
  content: "";
  display: block;
  position: absolute;
  left: 20px;
  top: 10px;
  width: 2px;
  height: 20px;
  background-color: #ffffff;
}

.back-login {
  display: inline-block;
  margin: 12px 0 18px 54px;
  color: #60a5fa;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
}

</style>
